import React, { useEffect, useState } from 'react';
import { Refresh as RefreshIcon } from '@material-ui/icons';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import Tooltip from '../../../components/common/StyledToolTip';

const Refresh = ({ classes, headerId, config, eventHub }) => {
  const [isRefreshInProgress, setIsRefreshInProgress] = useState(false);

  useEffect(() => {
    eventHub.on(`${headerId}_refreshInProgress`, handleRefreshProgress);
    return () => {
      eventHub.off(`${headerId}_refreshInProgress`, handleRefreshProgress);
    };
  }, [eventHub, headerId]);

  const handleRefreshProgress = (isRefreshInProgress) => {
    setIsRefreshInProgress(isRefreshInProgress);
  };

  const refreshData = () => {
    if (isRefreshInProgress) {
      return;
    }
    eventHub.emit(`${headerId}_refresh`);
  };

  const title = isRefreshInProgress
    ? config?.inProgressTitle || 'Refresh in progress'
    : config?.title || 'Refresh';
  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${isRefreshInProgress ? classes.disableIcon : ''}`}
      onClick={refreshData}>
      <Tooltip title={title}>
        <RefreshIcon />
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(Refresh);
